const bucketDefaults = (bucket) => {
  if (bucket && bucket.displayFields) {
    for (const displayField of bucket.displayFields) {
      displayField.sortDirection = "asc"
      displayField.sortPosition = 0
    }
  }
}

const caseTypeBucketDefaults = (caseType) => {
  if (caseType.buckets && Array.isArray(caseType.buckets)) {
    for (const bucket of caseType.buckets) {
      bucketDefaults(bucket)
    }
  }
  if (caseType.bucketGroups && Array.isArray(caseType.bucketGroups)) {
    for (const bucketGroup of caseType.bucketGroups) {
      if (bucketGroup.buckets && Array.isArray(bucketGroup.buckets)) {
        for (const bucket of bucketGroup.buckets) {
          bucketDefaults(bucket)
        }
      }
    }
  }
}

const providerResponseHandler = (response, errorMessage, successHandler) => {
  if (response) {
    if (response.error) {
      throw new Error(response.message)
    } else {
      successHandler()
    }
  } else {
    throw new Error(errorMessage)
  }        
}

export {
  bucketDefaults, caseTypeBucketDefaults, providerResponseHandler
}
